"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccommodationTypePriceHistoryDto {
}
exports.AccommodationTypePriceHistoryDto = AccommodationTypePriceHistoryDto;
